import Navigator from 'app';
import JournalHomeLayout from './views/journal_home_layout';
'';
import LegislativeDayControlView from './views/legislative_day_control_compositview';
import EventsView from './views/journal_event_compositview'; // Bill status tab
import VotesView from './views/journal_vote_compositview';
import ChamberMeetingsView from './views/committee_meeting_collectionview';
// import HouseMeetingsView         from  './views/house_meeting_collectionview';
// import SenateMeetingsView        from  './views/senate_meeting_collectionview';
import MeetingsLayout from './views/committee_meeting_layout';
import '../../entities/event/event_collection'; // bill status tab
import '../../entities/vote/vote_collection';
import '../../entities/common/legislative_day_collection';
import '../../entities/committee_meeting/house_meetings_collection';
import '../../entities/committee_meeting/senate_meetings_collection';
export default {
  showJournalHome: function () {
    Navigator.vent.trigger("loading:show");
    const journalHomeLayout = new JournalHomeLayout();
    const fetchingDays = Navigator.request("days");
    $.when(fetchingDays).done(function (days) {
      const legislativeDayControlView = new LegislativeDayControlView({
        collection: days
      });
      const mostRecentSessionDate = Navigator.days.models[legislativeDayControlView.index];
      const fetchingEvents = Navigator.request("event:daily", mostRecentSessionDate.get('legislative_day_date'));
      const fetchingVotes = Navigator.request("vote:daily", mostRecentSessionDate.get('legislative_day_date'));
      const fetchingSenateMeetings = Navigator.request("meetings:senate", "this_week", mostRecentSessionDate.get('legislative_day_date'));
      const fetchingHouseMeetings = Navigator.request("meetings:house", "this_week", mostRecentSessionDate.get('legislative_day_date'));
      $.when(fetchingEvents, fetchingVotes, fetchingSenateMeetings, fetchingHouseMeetings).done(function (events, votes, senateMeetings, houseMeetings) {
        const eventsView = new EventsView({
          collection: events
        }); // bill status
        const votesView = new VotesView({
          collection: votes
        });
        //const houseMeetingsView = new ChamberMeetingsView({collection: houseMeetings});
        //const senateMeetingsView = new ChamberMeetingsView({collection: senateMeetings});
        //const meetingsLayout = new MeetingsLayout();

        // meetingsLayout.on("show", function() {
        //   meetingsLayout.houseMeetingRegion.show(houseMeetingsView);
        //   meetingsLayout.senateMeetingRegion.show(senateMeetingsView);
        // });

        journalHomeLayout.on("show", function () {
          journalHomeLayout.legislativeDayRegion.show(legislativeDayControlView);
          journalHomeLayout.dailyEventsRegion.show(eventsView); // bill status
          journalHomeLayout.dailyVotesRegion.show(votesView);
          // commenting out for now because the scraper is broken or something, meeting schedule is not in the API
          //journalHomeLayout.meetingScheduleRegion.show(meetingsLayout);
        });

        Navigator.mainRegion.show(journalHomeLayout);
        Navigator.vent.trigger("loading:hide");
      });
    });
  }
};